{
  "id": "worker",
  "role": "worker",
  "speed": 96,
  "cost": {
    "gold": 50,
    "lumber": 0
  },
  "trainTicks": 100,
  "supply": 1,
  "hp": 30,
  "builds": ["barracks"],
  "gather": {
    "carry": 10,
    "miningTicks": 40,
    "choppingTicks": 60
  }
}
